import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { LargeCard } from "@components/patterns/LargeCard"
import { Chip } from "@components/ui/Chip"
import { BlogTileFragment } from "@generated-types"
import { formatNiceDate } from "@utils/date-format"
import { Link } from "eddev/routing"

type Props = BlogTileFragment

export function LargeBlogTile(props: Props) {
  return (
    <Link href={props.uri!}>
      <LargeCard
        title={props.title}
        infoWidth="md"
        height="lg"
        description={<div className="type-body-m" dangerouslySetInnerHTML={{ __html: props.excerpt! }} />}
        media={
          <ResponsiveImage {...props.info?.heroImage} className="md:absolute md:w-full md:h-full md:left-0 md:top-0" />
        }
        theme="orange"
        tags={[
          <Chip shape="rounded" variant="primary" key="date">
            {formatNiceDate(props.dateGmt!)}
          </Chip>,
          props.info?.category?.name && (
            <Chip shape="rounded" variant="primary" key="category">
              {props.info?.category?.name}
            </Chip>
          ),
        ]}
      />
    </Link>
  )
}
